import { Component } from '@angular/core';
import { MbsUiKitModule, ModalModule } from 'mbs-ui-kit';
import { I18NextModule } from 'angular-i18next';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mbs-add-destination-partial-success-modal',
  templateUrl: './add-destination-partial-success-modal.component.html',
  imports: [
    CommonModule,
    I18NextModule,
    ModalModule,
    MbsUiKitModule
  ],
  standalone: true
})
export class AddDestinationPartialSuccessModalComponent {
  public extensions: string[];
}
